export default {"src":"/_next/static/media/data-audits.34f7b999.svg","height":834,"width":626,"blurWidth":0,"blurHeight":0};